// extracted by mini-css-extract-plugin
export default {"container-input":"input-text_container-input__mPYuU","inline":"input-text_inline__W1jnO"};